import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { AssinaturaDigitalEvento } from './model/assinatura-digital-evento.model';


@Injectable({
  providedIn: 'root'
})
export class AssinaturaDigitalEventoService extends DefaultService<AssinaturaDigitalEvento> {
  static URL = '/api/seguranca/assinaturadigital/assinaturadigitalevento/v1/assinaturaDigitalEvento';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService
  ) {
    super(
      httpClient,
      errorHandlerService,
      AssinaturaDigitalEventoService.URL
    );
  }
}
